import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import router from '../../../../router'
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import moment from 'moment'
import Loader from './../../shared/loader'
import Pagination from './../../shared/pagination'
import createsalesreturn from '../../createsalesreturn'
import { BasicSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'

export default {
	name: 'srmaster',
	components: {
		BasicSelect,
		Paginate,
		Pagination,
		DatePicker,
		Loader,
		createsalesreturn
	},
	data: function() {
		return {
			// totalRows:0,
			selectedmerchant:{value:'',text:''},
			merchantList:[],
			isDispList: false,
			contentVisible:false,
			// currentPage: 0,
			// currentPage2: 0,
			resultCount: 0,
			resultCountDetail: 1,
			srDetailModal: false,
			useremail: '',
			warehouseid: '',
			isLoading: false,
			listSRData: [],
			listSRDetailData: [],
			clientListData: [],
			warehouseListData: [],
			clientid: '',
			totalPage: 0,
			totalRows:0,
			currentPage: 1,
			currentPage2: 1,
			pageLimit:10,
			totalPageDetail:0,
			totalRowsDetails:0,
			// pageno: 0,
			// totalPage: 0,
			// pageLimit: 5,
			// pagenoDetail: 0,
			// totalPageDetail: 0,
			status: '',
			awbnumber: '',
			orderid: '',
			fromdate: '',
			todate: '',
			couriercompany: '',
			srid: '',
			searchFlag: false,
			showSelectClient: false,
			showSelectWarehouse: false,
			showSelectMerchant:false,
			showlist:true,
			toCheckShowRowIndex: '',
			ClientErr: '',
			WarehouseErr: '',
			listWarehouseAll: [],
			client: '',
			warehouse: '',
			loginUserEmail: '',
			searchflag: false,
			user_type: '',
			listSRExtraProducts : [],
			extraCount : 0,
			listCourierData: [],
			listMerchantData:[],
			MerchantList: [],
			merchantid: '',
			merchant:'',
			selectedRow: {},
		   filterData: {},
		}
	},

	beforeCreate: function() {
		this.isLoading = true;
	},
	created: function() {},
	computed: {},
	filters: {
		moment: function(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YYYY');
		}
	},
	// when a page loads,mounted() will be call
	mounted() {

		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext)

		this.user_type = userdetail.utype;
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		if (localStorage.getItem("selectedClient")!='undefined')
		{
		this.getMerchantList();
		this.getcourierList();
		}
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				this.showSelectMerchant=true,

				this.loginUserEmail = userdetail.email;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.loginUserEmail = userdetail.email;
				this.showSelectMerchant=true,
				// this.getWarehouseList();
				this.getMerchantList();
				this.showSelectWarehouse = true;
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.showSelectClient = true;
				this.showSelectMerchant=true
				// this.getClientList();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break;

				// if(this.$route.params.isDisplay==true){
				//   if (this.user_type == 'warehouse_user') {
				//     this.client = this.$route.params.clientid;
				//     this.clientid = this.$route.params.clientid
				//   } else if (this.user_type == 'client_user') {
				//     this.warehouse = this.$route.params.warehouseid;
				//     this.warehouseid = this.$route.params.warehouseid
				//   } else {
				//     this.client = this.$route.params.clientid;
				//     this.clientid = this.$route.params.clientid
				//     this.warehouse = this.$route.params.warehouseid;
				//     this.warehouseid = this.$route.params.warehouseid
				//   }
				//   this.getSRMasterListSearch();
				// }

		}
		this.getcourierList();

	},
	methods: {
		callParent() {
			this.showlist = true;
		},
		selectMerchant(data){
			this.selectedmerchant = data;
			this.merchant = data.value;
		  },
		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD hh:mm:ss');
		},

		getcourierList() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');

     this.input = ({});

      axios({
          method: 'GET',
          'url': apiUrl.api_url + 'courierlistRTO',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
          this.listCourierData = result.data.rows;
        }, error => {
          console.error(error)
        })
    },

		// getWarehouseList() {
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseAll = JSON.parse(plaintextwarehouse);
		// 	} else {

		// 	var userToken = window.localStorage.getItem('userToken')
		// 	var myStr = userToken.replace(/"/g, '');
		// 	this.pageno = 0;

		// 	this.input = ({
		// 		clientid: this.clientid,
		// 	});

		// 	axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 		.then(result => {
		// 			this.listWarehouseAll = result.data.data;
		// 		}, error => {
		// 			console.error(error)
		// 		})
		// 	}
		// },

		getSRMasterList() {
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				return false;
			}

			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				return false;
			}
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.resultCount = 0;
			this.input = ({
				offset: (this.currentPage - 1) * this.pageLimit,
				limit: this.pageLimit,
				warehouseid: localStorage.getItem('selectedWarehouse'),
				clientid: localStorage.getItem('selectedClient'),
				status: this.status,
				awbno: this.awbnumber,
				orderid: this.orderid,
				fromdate: this.fromdate,
				todate: this.todate,
				couriercompany: this.couriercompany,
				clientid: localStorage.getItem('selectedClient')
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getSRMasterList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.isLoading = false;
					this.listSRData = result.data.data

					this.totalRows = result.data.count
					this.resultCount = result.data.count
					if (this.resultCount > 0) {
						if (this.totalRows < this.pageLimit) {
							this.totalPage = 1
						} else {
							this.totalPage = Math.ceil(this.totalRows / this.pageLimit)
						}
					}
				}, error => {
					console.error(error)
				})
		},
		getSRMasterSearchData(){
			this.currentPage = 1 ;
			this.searchflag=true;
			this.getSRMasterListSearch();
		},

		getSRMasterListSearch() {
			if (localStorage.getItem('selectedWarehouse') == 'undefined' || localStorage.getItem('selectedClient') == 'undefined') {
				if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
					this.$alertify.error(this.$t('common.clientError'))
					return false;
				}

				if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
					this.$alertify.error(this.$t('common.warehouseError'))
					return false;
				}
				return false;
			} else {
				var fr_date = '';
				var to_date = '';
				this.searchFlag = true;

				if (this.fromdate == '') {
					fr_date = '';
				} else {
					fr_date = this.dateFormat(this.fromdate)
				}
				if (this.todate == '') {
					to_date = '';
				} else {
					to_date = this.dateFormat(this.todate)
				}

				var userToken = window.localStorage.getItem('userToken')
				var myStr = userToken.replace(/"/g, '');
				this.input = ({
					offset: (this.currentPage - 1) * 5,
					limit: this.pageLimit,
					warehouseid: localStorage.getItem('selectedWarehouse'),
					clientid: localStorage.getItem('selectedClient'),
					status: this.status,
					merchantid:this.merchant,
					awbno: this.awbnumber.trim(),
					orderid: this.orderid.trim(),
					fromdate: fr_date,
					todate: to_date,
					couriercompany: this.couriercompany.trim()
				})
				this.filterData = this.input
				this.isLoading = true;
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'getSRMasterList',
						'data': this.input,
						headers: {
							'Authorization': 'Bearer ' + myStr
						}
					})
					.then(result => {
						this.resultCount = 0;
						this.isLoading = false;
						this.listSRData = result.data.data

						this.totalRows = result.data.count
						this.resultCount = result.data.count
						if (this.resultCount > 0) {
							if (this.totalRows < this.pageLimit) {
								this.totalPage = 1
							} else {
								this.totalPage = Math.ceil(this.totalRows / this.pageLimit)
							}
						} else {
							this.totalPage = 0
						}
					}, error => {
						console.error(error)
					})
			}
		},

		// getNewClientData() {
		//   this.awbnumber = '';
		//   this.orderid = '';
		//   this.originwarehouseid = '';
		//   this.receivedwarehouseid = '';
		//   this.couriercompany = '';
		//   this.fromdate = '';
		//   this.todate = '';
		//   this.status = '';
		//   this.searchFlag = false;
		//   this.pageno = 0;
		//   this.totalPage = 0;
		//   this.resultCount = 0;
		//   this.listSRData = [];
		//   this.searchFlag = false;
		//
		//   document.getElementById("awbnumber").value = "";
		//   document.getElementById("orderid").value = "";
		//   document.getElementById("originwarehouseid").value = "";
		//   document.getElementById("receivedwarehouseid").value = "";
		//   document.getElementById("couriercompany").value = "";
		//   document.getElementById("status").value = "";
		//
		//   if (this.clientid == "") {
		//     return false;
		//   } else {
		//     this.getwarehouselist();
		//     this.getSRMasterList();
		//   }
		//
		// },

		// clientSelected() {
		// 	if (this.clientid != this.client ||this.clientid == this.client) {
		// 		this.clientid = this.client;
		// 		this.listWarehouseData = []
		// 		this.merchant='';
		// 		this.merchantList=[]
		// 		this.selectedmerchant={}
		// 		this.getWarehouseList();
		// 		this.getMerchantList();
        //  this.warehouse = ''
		// 		if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 			this.warehouse = this.warehouseid = '';
		// 		}
		// 	}

		// 	this.clientid = this.client;
		// 	if (this.clientid) {
		// 		this.merchantList=[]
		// 		this.selectedmerchant={}
		// 		this.resetForm();
		// 		if (this.warehouseid == '') {
		// 			this.getWarehouseList();
		// 		}
		// 	}
		// },

		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	this.resetForm();
		// 	if (this.warehouseid) {
		// 		if (this.clientid == '') {
		// 			this.getClientList();
		// 		}
		// 	}
		// },

		resetForm() {

			this.lpnid = '';
			this.awbnumber = '';
			this.orderid = '';
			this.totalPage = 0;
			this.merchant='';
			this.pageno = 0;
			this.searchFlag = false;
			document.getElementById('orderid').value = ''
			document.getElementById('awbnumber').value = ''
			document.getElementById('couriercompany').value = ''
			this.status = '';
			this.fromdate = '';
			this.todate = '';
			this.couriercompany = '';
			this.listSRData = [];
			this.totalRows=0;
			this.resultCount = 0;
			this.searchFlag = false;

		},
		resetSearchForm() {
			this.lpnid = '';
			this.awbnumber = '';
			this.orderid = '';
			this.status = '';
			this.fromdate = '';
			this.merchant='';
			this.todate = '';
			this.couriercompany = '';
			this.merchant='';
			this.listSRData = [];
			this.resultCount = 0;
			this.totalRows=0;
			this.totalPage = 0;
			this.pageno = 0;
			this.searchFlag = false;
			// this.merchantList=[]
			this.selectedmerchant={}
			// if (this.user_type == 'warehouse_user') {
			// 	this.client = '';
			// 	this.clientid = ''
			// } else if (this.user_type == 'client_user') {
			// 	this.warehouse = '';
			// 	this.warehouseid = ''
			// } else {
			// 	this.client = '';
			// 	this.clientid = ''
			// 	this.warehouse = '';
			// 	this.warehouseid
			// }
		},
		viewSRPDetailPopUp(data) {
			this.contentVisible=false;
			// this.srDetailModal = true;
			this.srid = data.srid;
			this.isLoading = true;
			this.getAllSRProducts(data);
			this.toCheckShowRowIndex = Number(this.listSRData.indexOf(data))
			for (var i = 0; i < this.listSRData.length; i++) {
				if (i != this.toCheckShowRowIndex || this.listSRData[i].contentVisible==true) {
					this.listSRData[i].contentVisible = false
				}
				else{
					this.listSRData[i].contentVisible = true

				}
			}
		},

		getAllSRProducts(data) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				offset: 0,
				limit: 50,
				warehouseid: localStorage.getItem('selectedWarehouse'),
				clientid: localStorage.getItem('selectedClient'),
				srid: data.srid

			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getSRProductDetails',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.isLoading = false;
					this.contentVisible = true;
					this.listSRDetailData = result.data.data;
					this.listSRExtraProducts = result.data.extraProductdata;
					this.extraCount = result.data.extracount;
					this.totalRowsDetails = result.data.count ;
					this.resultCountDetail = result.data.count
					if (	this.totalRowsDetails < 10) {
						this.totalPageDetail = 1
					} else {
						this.resultCountDetail = 0;
						this.totalPageDetail = Math.ceil(	this.totalRowsDetails / 10)
					}
				}, error => {
					console.error(error)
				})

		},
		//to get Client list
		// getClientList() {
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.clientListData = JSON.parse(plaintextclient);
		// 	} else {
		// 	var userToken = window.localStorage.getItem('userToken')
		// 	var myStr = userToken.replace(/"/g, '');
		// 	this.resultCount = 0;
		// 	this.input = ({
		// 		warehouseid: this.warehouseid,
		// 	});
		// 	axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 		.then(result => {
		// 			this.clientListData = result.data.data;
		// 		}, error => {
		// 			console.error(error)
		// 		})
		// 	}
		// },

		closeSRDetailModal() {
			this.srDetailModal = false;
		},

		//to get pagination For SR List
		// getPaginationData(currentPage) {
		// 	this.pageno = (currentPage - 1) * this.pageLimit;
		// 	this.getSRMasterListSearch();
		// },
		onPageChange(page) {
		  this.currentPage = page;
		  this.getSRMasterListSearch()
		},
		//to get pagination For SR Detail
		getPaginationDataDetail(currentPage2) {
		  this.currentPage2 = page;
			this.getAllSRProducts()
		},
		createSR(data) {
			this.selectedRow = data
			this.showlist = false;
			// router.push({
			// 	name: "createsalesreturn"
			// });
		},
		getMerchantList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: this.clientid,
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'merchantList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (result.data && result.data.length > 0) {
						this.listMerchantData = result.data;
						this.merchantList.push({
							value:'',text: this.$t('common.selectMerchantPlaceHolder')}
						   )
						  for (var i = 0; i < this.listMerchantData.length; i++) {
							this.merchantList.push({
							'value': this.listMerchantData[i].merchantid,
							'text': this.listMerchantData[i].merchantname
							});
						  }
					}
				}, error => {
					console.error(error)
				})
		},

	}
}



// WEBPACK FOOTER //
// ./src/views/components/sr/srmaster/srmaster.component.js